export const checkNumberWith10Digit = str => {
  const regex = /^(?=.*\d)(?=.*[0-9])(?=.*[^\d\s]*[0-9])[0-9]{10}$/;
  return regex.test(str);
};

export const isValidEmail = email => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};
